import { useNavigate } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { appRoutes } from '@/constants'

export function PromotionalBannersSection() {
  const navigate = useNavigate()

  return (
    <section className="py-8" style={{ backgroundColor: 'var(--color-bg-main)' }}>
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

          {/* LEFT: Certified Pre-Owned Cars */}
          <div
            className="relative overflow-hidden"
            style={{ borderRadius: '16px', minHeight: '200px' }}
          >
            {/* Background image */}
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: `url('https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?q=80&w=900&auto=format&fit=crop')`,
              }}
            />
            {/* Dark overlay */}
            <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(0,0,0,0.80) 0%, rgba(0,0,0,0.35) 100%)' }} />

            {/* Content */}
            <div className="relative z-10 p-7 flex flex-col justify-end h-full" style={{ minHeight: '200px' }}>
              {/* Badge */}
              <span
                style={{
                  display: 'inline-block',
                  backgroundColor: '#CF2F2F',
                  color: '#fff',
                  fontFamily: "'DM Sans', sans-serif",
                  fontWeight: 700,
                  fontSize: '9px',
                  letterSpacing: '0.12em',
                  padding: '3px 8px',
                  borderRadius: '4px',
                  textTransform: 'uppercase',
                  marginBottom: '10px',
                  width: 'fit-content',
                }}
              >
                RESOLD AUTOMOTIVE
              </span>

              <h3
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 800,
                  fontSize: 'clamp(18px, 2.5vw, 26px)',
                  color: '#fff',
                  lineHeight: 1.1,
                  marginBottom: '8px',
                  textTransform: 'uppercase',
                }}
              >
                CERTIFIED PRE-OWNED CARS
              </h3>

              <p
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '12px',
                  color: 'rgba(255,255,255,0.75)',
                  marginBottom: '16px',
                  lineHeight: 1.5,
                  maxWidth: '320px',
                }}
              >
                Inspected vehicles with clean titles, verified service histories, and comprehensive warranty programs.
              </p>

              <button
                type="button"
                onClick={() => navigate(appRoutes.cars)}
                style={{
                  backgroundColor: '#CF2F2F',
                  color: '#fff',
                  fontFamily: "'DM Sans', sans-serif",
                  fontWeight: 700,
                  fontSize: '11px',
                  letterSpacing: '0.06em',
                  textTransform: 'uppercase',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '9px 18px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  width: 'fit-content',
                  transition: 'opacity 0.2s',
                }}
                onMouseEnter={e => (e.currentTarget.style.opacity = '0.88')}
                onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
              >
                <ArrowRight size={13} />
                EXPLORE PRE-OWNED
              </button>
            </div>
          </div>

          {/* RIGHT: Genuine & Old Parts */}
          <div
            className="relative overflow-hidden"
            style={{ borderRadius: '16px', minHeight: '200px' }}
          >
            {/* Background image */}
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: `url('https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=900&auto=format&fit=crop')`,
              }}
            />
            {/* Dark overlay */}
            <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.38) 100%)' }} />

            {/* Content */}
            <div className="relative z-10 p-7 flex flex-col justify-end h-full" style={{ minHeight: '200px' }}>
              {/* Badge */}
              <span
                style={{
                  display: 'inline-block',
                  backgroundColor: '#CF2F2F',
                  color: '#fff',
                  fontFamily: "'DM Sans', sans-serif",
                  fontWeight: 700,
                  fontSize: '9px',
                  letterSpacing: '0.12em',
                  padding: '3px 8px',
                  borderRadius: '4px',
                  textTransform: 'uppercase',
                  marginBottom: '10px',
                  width: 'fit-content',
                }}
              >
                SPARES &amp; REPLACEMENTS
              </span>

              <h3
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 800,
                  fontSize: 'clamp(18px, 2.5vw, 26px)',
                  color: '#fff',
                  lineHeight: 1.1,
                  marginBottom: '8px',
                  textTransform: 'uppercase',
                }}
              >
                GENUINE &amp; OLD PARTS
              </h3>

              <p
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '12px',
                  color: 'rgba(255,255,255,0.75)',
                  marginBottom: '16px',
                  lineHeight: 1.5,
                  maxWidth: '320px',
                }}
              >
                Sourced direct OEM fitments, aftermarket tuning kits, and comprehensive pre-owned components.
              </p>

              <button
                type="button"
                onClick={() => navigate(appRoutes.parts)}
                style={{
                  backgroundColor: '#CF2F2F',
                  color: '#fff',
                  fontFamily: "'DM Sans', sans-serif",
                  fontWeight: 700,
                  fontSize: '11px',
                  letterSpacing: '0.06em',
                  textTransform: 'uppercase',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '9px 18px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  width: 'fit-content',
                  transition: 'opacity 0.2s',
                }}
                onMouseEnter={e => (e.currentTarget.style.opacity = '0.88')}
                onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
              >
                <ArrowRight size={13} />
                BROWSE SPARES
              </button>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}
